import { render, staticRenderFns } from "./ysxy.vue?vue&type=template&id=f2ca5eb2&scoped=true"
import script from "./ysxy.vue?vue&type=script&lang=js"
export * from "./ysxy.vue?vue&type=script&lang=js"
import style0 from "./ysxy.vue?vue&type=style&index=0&id=f2ca5eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ca5eb2",
  null
  
)

export default component.exports